document.addEventListener('DOMContentLoaded', function () {
  const images = document.querySelectorAll('.product__media img, .product-single__photo img');

  images.forEach(function (img) {
    const wrapper = img.closest('.product__media, .product-single__photo');
    if (!wrapper || wrapper.querySelector('.zoom-btn')) return;

    wrapper.style.position = 'relative';

    const btn = document.createElement('button');
    btn.className = 'zoom-btn';
    btn.setAttribute('aria-label', 'Zoom image');
    btn.innerHTML = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none">
      <circle cx="7.5" cy="7.5" r="5" stroke="currentColor" stroke-width="1.5"/>
      <line x1="11.3" y1="11.3" x2="15.5" y2="15.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      <line x1="6" y1="7.5" x2="9" y2="7.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      <line x1="7.5" y1="6" x2="7.5" y2="9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>`;
 btn.addEventListener('mouseenter', function () {
  const fullSrc = img.dataset.src 
    || (img.srcset && img.srcset.split(',').pop().trim().split(' ')[0])
    || img.src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|x-large|really_big|huge|master)\./, '_1800x.')
    || img.src;
  const pre = new Image();
  pre.src = fullSrc;
});

btn.addEventListener('click', function () { openZoom(img); });
    wrapper.appendChild(btn);
  });

 function openZoom(img) {
  const fullSrc = img.dataset.src 
    || (img.srcset && img.srcset.split(',').pop().trim().split(' ')[0])
    || img.src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|x-large|really_big|huge|master)\./, '_1800x.')
    || img.src;

  // Preload starts immediately on hover
  const preloaded = new Image();
  preloaded.src = fullSrc;

  const overlay = document.createElement('div');
  overlay.className = 'zoom-overlay';
  overlay.innerHTML = `
    <div class="zoom-overlay__inner">
      <button class="zoom-overlay__close" aria-label="Close">&times;</button>
      <div class="zoom-spinner"></div>
      <img src="${fullSrc}" alt="Zoomed product image" style="display:none;" />
    </div>`;

  const zoomedImg = overlay.querySelector('img');
  const spinner = overlay.querySelector('.zoom-spinner');

  zoomedImg.addEventListener('load', function () {
    spinner.remove();
    zoomedImg.style.display = 'block';
  });

  overlay.querySelector('.zoom-overlay__close').addEventListener('click', () => overlay.remove());
  overlay.addEventListener('click', (e) => { if (e.target === overlay) overlay.remove(); });
  document.body.appendChild(overlay);
}
});